import { useCallback, useEffect } from "react";
import { useBnbSelector } from "../../redux/store";
import useGetProaceGalleryFrame from "./useGetProaceGalleryFrame";
import useSpinner, { type GetImageSrcType } from "../../../../../common-deprecated/hooks/spin/useSpinner";
import { getModelFilterSilderImageCode, getModelFilterSlideTypes } from "../../utils/typedUtils";

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
const useProAceGallery = () => {
    const modelFilter = useBnbSelector((state) => state.modelFilter);

    const { getImage, cacheKey } = useGetProaceGalleryFrame();
    const getImageSrc = useCallback(
        (frame: number): GetImageSrcType => ({
            src: getImage(450, 200, frame),
            srcSet: `${getImage(450, 200, frame)} 1x, ${getImage(900, 400, frame)} 2x`,
            sizes: "",
        }),
        [cacheKey],
    );

    const slideTypes = getModelFilterSlideTypes(modelFilter);
    const frameProps = useSpinner(getImageSrc, cacheKey, 0, slideTypes.length);
    const { currentFrame, showPrevImg, imageCache, previousImg, setCurrentFrame } = frameProps;

    // Scroll to the correct slider index when a filter  has been updated.
    const { lastSelectedFilterCode } = modelFilter;
    useEffect(() => {
        if (lastSelectedFilterCode) {
            const slideIndex = slideTypes.findIndex(
                (slide) => slide.type === getModelFilterSilderImageCode(lastSelectedFilterCode),
            );
            // If no slide mage is found matching the last slider you've interacted with, do nothing.
            if (slideIndex !== -1 && slideIndex !== currentFrame) setCurrentFrame(slideIndex);
        }
    }, [lastSelectedFilterCode]);

    return {
        cacheKey,
        currentFrame,
        getImageSrc,
        imageCache,
        previousImg,
        setCurrentFrame,
        showPrevImg,
    };
};

export default useProAceGallery;
